/* Size guide semantics and focus lifecycle. Visual layout stays in existing CSS. */
(function () {
  'use strict';
  function initialize() {
    var modal = document.getElementById('size-guide-modal');
    if (!modal || modal.dataset.dialogInitialized) return;
    modal.dataset.dialogInitialized = 'true';
    var openBtn = document.getElementById('open-size-guide');
    var closeBtn = document.getElementById('close-size-guide');
    var heading = document.getElementById('size-guide-heading');
    var header = document.getElementById('shopify-section-header');
    var opened = false;
    var returnFocus;
    var previousOverflow;
    var headerWasHidden;
    var background = [];
    var closeTimer;

    function openers() {
      return document.querySelectorAll('#open-size-guide, [data-sticky-size-guide], [data-size-width-line]');
    }
    function setExpanded(value) {
      openers().forEach(function (control) {
        control.setAttribute('aria-haspopup', 'dialog');
        control.setAttribute('aria-controls', 'size-guide-modal');
        control.setAttribute('aria-expanded', String(value));
      });
    }
    // Only siblings of the dialog's ancestor path become inert, never the dialog.
    function lockBackground() {
      var child = modal;
      while (child.parentElement) {
        Array.from(child.parentElement.children).forEach(function (sibling) {
          if (sibling === child || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          background.push({ element: sibling, inert: sibling.inert });
          sibling.inert = true;
        });
        child = child.parentElement;
        if (child === document.body) break;
      }
    }
    function openSizeGuide(source) {
      if (opened) return;
      clearTimeout(closeTimer);
      opened = true;
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      headerWasHidden = header && header.classList.contains('hide-header');
      modal.style.display = 'flex';
      modal.inert = false;
      modal.setAttribute('aria-hidden', 'false');
      setExpanded(true);
      document.dispatchEvent(new CustomEvent('size-guide:open', { detail: { source: source || 'other' } }));
      document.body.style.overflow = 'hidden';
      if (header) header.classList.add('hide-header');
      lockBackground();
      // Focus a heading, not an input: opening the guide must not summon a keyboard.
      heading.focus({ preventScroll: true });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (opened) modal.classList.add('size-guide-modal--animating');
        });
      });
    }
    function closeSizeGuide() {
      if (!opened) return;
      opened = false;
      modal.classList.remove('size-guide-modal--animating');
      background.forEach(function (entry) { entry.element.inert = entry.inert; });
      background = [];
      document.body.style.overflow = previousOverflow;
      if (header && !headerWasHidden) header.classList.remove('hide-header');
      setExpanded(false);
      var target = returnFocus && returnFocus.isConnected && !returnFocus.closest('[inert]') ? returnFocus : openBtn;
      if (target) target.focus({ preventScroll: true });
      modal.setAttribute('aria-hidden', 'true');
      modal.inert = true;
      function hide() { if (!opened) modal.style.display = 'none'; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) hide();
      else closeTimer = setTimeout(hide, 450);
    }
    modal.addEventListener('keydown', function (event) {
      if (!opened) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeSizeGuide();
      } else if (event.key === 'Tab') {
        var controls = Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function (el) {
          return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length > 0;
        });
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); heading.focus({ preventScroll: true }); }
        else if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    if (openBtn) openBtn.addEventListener('click', function (event) { event.preventDefault(); openSizeGuide('size_link'); });
    if (closeBtn) closeBtn.addEventListener('click', function (event) { event.preventDefault(); closeSizeGuide(); });
    modal.addEventListener('click', function (event) { if (event.target === modal) closeSizeGuide(); });
    window.openSizeGuide = openSizeGuide;
    setExpanded(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
